import {
  Autocomplete,
  Button,
  Divider,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import {
  ChangeEvent,
  SyntheticEvent,
  useContext,
  useEffect,
  useState,
} from "react";
import { DoctorLicenseTpe, initialLicense, MasterTableDataType } from "./types";
import { DoctorMasterDataContext } from "./context/DoctorMasterDataProvider";
import { useQuery } from "react-query";
import { getpostOfficeService } from "../../../PatientCare/patientEncounter/services";
import { useLocation } from "react-router-dom";
import { PostOfficeType } from "PatientCare/patientEncounter/v1/Type/EncounterTypes";

function DoctorLicense() {
  const [edit, setEdit] = useState<DoctorLicenseTpe | null>(null);
  const { licenseList, setLicenseList } = useContext(DoctorMasterDataContext);
  const [selected, setSelected] = useState<number>(-1);
  const [errorState, setErrorState] = useState<boolean>(false);
  const { data: postOffices, isLoading: postOfficeLoading } = useQuery(
    ["doctorMasersOpstoffice"],
    getpostOfficeService,
    {
      refetchOnWindowFocus: false,
    }
  );

  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };

  const handleAdd = () => {
    setLicenseList((prev) => [
      { ...initialLicense, doctorLicenseId: data?.id || 0 },
      ...prev,
    ]);
    setEdit({ ...initialLicense, doctorLicenseId: data?.id || 0 });
    setSelected(0);
  };
  const handlePostOfficeChange = (
    _: SyntheticEvent,
    option: PostOfficeType | null
  ) => {
    setEdit(
      (prev) =>
        prev && {
          ...prev,
          postofficename: option?.poName || null,
          poId: option?.poId || null,
        }
    );
  };

  const handleChangeLicenseLode = (e: ChangeEvent<HTMLInputElement>) => {
    setEdit(
      (prev) =>
        prev && {
          ...prev,
          licensecode: e.target.value,
        }
    );
  };

  const handleSave = () => {
    if (edit?.poId && edit?.licensecode) {
      const update = [...licenseList];
      update[selected] = edit as DoctorLicenseTpe;
      setLicenseList(update);
      setErrorState(false);
      setEdit(null);
      setSelected(-1);
    } else {
      setErrorState(true);
    }
  };

  const handleClose = () => {
    if (licenseList[0]?.licensecode && licenseList[0]?.poId) {
      console.log("condition true");
      setSelected(-1);
      setEdit(null);
    } else {
      const update = [...licenseList];
      update.shift();
      setLicenseList(update);
      setEdit(null);
    }
  };

  const handleEdit = (item: DoctorLicenseTpe, index: number) => {
    setEdit(item);
    setSelected(index);
  };

  const handleDelete = (index: number) => {
    const update = licenseList.filter((_, i) => i != index);
    setLicenseList(update);
  };

  useEffect(() => {
    return () => {
      setEdit(null);
      setSelected(-1);
    };
  }, []);

  return (
    <div className="py-3 px-2">
      <>
        <div className="flex gap-2 px-2 pb-2 justify-between items-center">
          <div>
            {data?.name && (
              <Typography fontWeight={"600"}>Dr {data?.name}</Typography>
            )}
          </div>
          <Button
            disabled={Boolean(edit)}
            color="success"
            endIcon={<AddIcon />}
            onClick={handleAdd}
          >
            add
          </Button>
        </div>
        <Divider />
        <div className="border">
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {headings.map((title) => (
                    <TableCell>{title}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <CustomTableBody
                alert={"No data"}
                dataLoading={false}
                isData={Boolean(licenseList?.length)}
                totalSpan={{ row: 5, col: headings.length }}
              >
                {licenseList?.map((license, index) =>
                  Boolean(edit && selected == index) ? (
                    <TableRow>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell width={500}>
                        <Autocomplete
                          fullWidth
                          loading={postOfficeLoading}
                          value={
                            edit?.poId
                              ? {
                                  password2: "",
                                  poId: edit.poId as number,
                                  poPassword: "",
                                  poClinicLicense: "",
                                  poUserName: "",
                                  poClinicId: 0,
                                  poName: edit.postofficename as string,
                                  poLink: "",
                                  uplink: "",
                                }
                              : null
                          }
                          options={postOffices?.response || []}
                          getOptionLabel={(option) => option.poName}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label="Select post office"
                              error={Boolean(!edit?.poId && errorState)}
                            />
                          )}
                          onChange={handlePostOfficeChange}
                        />
                      </TableCell>
                      <TableCell width={500}>
                        <TextField
                          variant="standard"
                          label={
                            edit?.postofficename === "DHPO"
                              ? "Enter license code (should start with MOHD)"
                              : "Enter license code"
                          }
                          value={edit?.licensecode}
                          onChange={handleChangeLicenseLode}
                          error={Boolean(!edit?.licensecode && errorState)}
                        />
                      </TableCell>
                      <TableCell width={200}>
                        <IconButton color="success" onClick={handleSave}>
                          <DoneIcon />
                        </IconButton>
                        <IconButton color="error" onClick={handleClose}>
                          <CloseIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableRow>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell width={500}>
                        {license.postofficename}
                      </TableCell>
                      <TableCell>{license.licensecode}</TableCell>
                      <TableCell width={200}>
                        <div className="flex gap-2">
                          <IconButton
                            color={"primary"}
                            onClick={() => [handleEdit(license, index)]}
                          >
                            <EditIcon />
                          </IconButton>
                          {license.id == 0 && (
                            <IconButton
                              color={"error"}
                              onClick={() => {
                                handleDelete(index);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </CustomTableBody>
            </Table>
          </TableContainer>
        </div>
      </>
    </div>
  );
}

export default DoctorLicense;
const headings = ["Sl no", "post office", "license code", "Actions"];
